import React, {useEffect,  useState} from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "../../base-components/base-paragraph";
import InputField from "../../base-components/base-input";
import StepsLoader from "../steps-loader";
import StepFooterAction from "../../base-components/step-footer-action";

const PageBus = window.PageBus

const EmailStep = ({ _step_service, error, step_ID, step_URL, next_step, setDataToContext, getDataFromContext, step_form, getStep}) => {

    const data = getDataFromContext(step_ID)
    const [inputData, setInputData] = useState({ ...data })
    const [isValid, setIsValid] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    const getInputValue = (name, value) => {
        setInputData({
            ...inputData,
            [name] : value
        })
        setDataToContext(step_ID, step_URL, name, value)    
    }

    // const isValidEmail = (e) => (/^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z0-9.-]+$/.test(e))
    const isValidEmail = (e) => (/^[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+@[a-zA-Z0-9_!#$%&'*+/=?`{|}~^.-]+\.[a-zA-Z0-9-][a-zA-Z0-9-]+$/.test(e))
    const isValidForm = () => ( isValidEmail(inputData.email))
    const action = () => {
        _step_service({step_ID, setIsLoading, next_step})
    }

    useEffect(()=> {
        setIsValid(isValidForm())
    }, [inputData])

    useEffect(() => {

         if (PageBus) {
            PageBus.publish(
                "analyticsServices", {
                  pageID: "onboarding",
                    stepSeq: "1",
                    stepName: "personal info:email address",
                    flowType: "sales",
                    flowName: "onboarding",
                    productName: "onboarding",
                    trackMethod: "flow"
            }
            );
        }
    }, [])

    return (
        <>
        <StepsLoader loading={isLoading}>
            <form>

            <BaseParagraph>
                <h3>{t('personal_infos.Personal_info_email_address.title')}</h3>
                <p>{t('personal_infos.Personal_info_email_address.text')}</p>
            </BaseParagraph>
                    {step_form.map(input => (
                        <InputField
                            type={input.type}
                            id={input.id}
                            error={error}
                            name={input.id}
                            label={t(input.label)}
                            value={inputData[input.id] !== "NULL" && inputData[input.id] !== "-1" && inputData[input.id] }
                            checked={inputData[input.id] !== "-1" && inputData[input.id] !== "NULL" && inputData[input.id]}
                            checkboxLabel={t('personal_infos.Personal_info_email_address.opt_in')}
                            getInputValue={getInputValue} key={input.id} />))}
            </form>

            <StepFooterAction caption={t('general.continue')}  action={action} link={next_step} disabled={!isValid} />

        </StepsLoader>
        </>
    )
}

EmailStep.propTypes = {
    step_ID: PropTypes.string,
    step_URL: PropTypes.string,
    next_step: PropTypes.string,
    setDataToContext: PropTypes.any,
    getDataFromContext: PropTypes.any,
    step_form: PropTypes.array,
    error: PropTypes.array,
    _step_service: PropTypes.func,

}

EmailStep.defaultProps = {
    name: "email-step"
}


export default EmailStep